import { FormattedMessage } from 'react-intl';

import { Typography, useTheme } from '@mui/material';

import styled from 'styled-components';

import { useFormatPercent } from '@arrived/hooks';

import { TextWrapper } from '../../../../TextWrapper';
import { Currency } from '../Currency';

const StyledTotalReturn = styled.div`
  &.calculator-total-return {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: ${({ theme }) => theme.spacing(3, 0)};
    gap: ${({ theme }) => theme.spacing(2)};

    .total-return-percentage {
      .currency {
        background: ${({ theme }) => theme.gradients.sea.horizontal};
        background-clip: border-box;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }

      .calculator-total-return-percent {
        font-size: 13px;
        background: ${({ theme }) => theme.gradients.sea.horizontal};
        color: ${({ theme }) => theme.palette.neutrals.white};
        padding: ${({ theme }) => theme.spacing(0.25, 1)};
      }
    }
  }
`;

interface CalculatorTotalReturnSectionProps {
  totalReturn: number;
  totalReturnRate: number;
}

export const CalculatorTotalReturnSection = ({ totalReturn, totalReturnRate }: CalculatorTotalReturnSectionProps) => {
  const formatPercent = useFormatPercent();
  const { palette } = useTheme();
  const sign = totalReturn > 0 ? '+' : '';
  return (
    <StyledTotalReturn className="calculator-total-return">
      <TextWrapper
        className="calculator-total-return-title"
        typographyProps={{ variant: 'body1' }}
        formattedMessageProps={{
          id: 'calculator-total-return-title',
          defaultMessage: 'Total Hypothetical Return',
        }}
      />
      <Currency
        className="total-return-percentage"
        color={palette.neutrals.white}
        unitOfTime={<FormattedMessage id="calculator-per-year-total-return" defaultMessage="Year" />}
        value={totalReturn}
        sign={sign}
        after={
          <Typography className="calculator-total-return-percent" variant="body2.semibold">
            {sign + formatPercent(totalReturnRate)}
          </Typography>
        }
        emphasize
      />
    </StyledTotalReturn>
  );
};
